module.exports = __webpack_public_path__ + "static/img/add-paper.27ddd1f5.png";